import { Route, Routes } from "react-router-dom";
import { SideBar, Navbar } from "./components";
import { AddProduct, AllCatalogs, AllProducts, NewDetail } from "./pages";
import styles from "./index.module.scss";
import EditProduct from "./pages/EditProduct";
import AddCatalog from "./pages/AddToCatalog";
import CatalogDetails from "./pages/CatalogDetails";

const Admin = () => {
  return (
    <div className={styles.admin}>
      <div className={styles.content}>
        <SideBar />
        <div style={{ width: "100%" }}>
          <Navbar />
          <div className={styles.routes}>
            <Routes>
              <Route path="/" element={<AllProducts />} />
              <Route path="/add" element={<AddProduct />} />
              <Route path="/edit/:id" element={<EditProduct />} />
              <Route path="/catalogs" element={<AllCatalogs />} />
              <Route path="/catalogs/:catalogType" element={<AddCatalog />} />
              <Route path="/catalog/:catalogType" element={<CatalogDetails/>} />
              <Route path="/newDetail" element={<NewDetail />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin;
